import { indiaDay, outstandingSummary } from './outstanding';
import { swilRequest } from './swil';

const pending = new Map();
const cacheKey = id => `scpaul:customer-balance:v1:${id}`;
export function savedCustomerBalance(id) {
  try {
    const entry = JSON.parse(localStorage.getItem(cacheKey(id)));
    if (!entry || !Array.isArray(entry.rows) || !Number.isFinite(Date.parse(entry.updatedAt)) || Date.parse(entry.updatedAt) > Date.now()) return null;
    outstandingSummary(entry.rows);
    if (entry.rows.some(row => String(row.FKCustomerID ?? row.CustomerID ?? row.customer_id) !== String(id))) return null;
    return entry;
  } catch { return null; }
}
export function loadCustomerBalance(id, force = false) {
  if (pending.has(String(id))) return pending.get(String(id));
  const saved = savedCustomerBalance(id);
  if (!force && saved && indiaDay(new Date(saved.updatedAt)) === indiaDay()) return Promise.resolve(saved);
  const request = swilRequest('outstanding', { customer_id: id }).then(data => {
    outstandingSummary(data.rows);
    const entry = { rows: data.rows, updatedAt: new Date().toISOString() };
    try { localStorage.setItem(cacheKey(id), JSON.stringify(entry)); }
    catch { entry.cacheUnavailable = true; }
    return entry;
  }).finally(() => pending.delete(String(id)));
  pending.set(String(id), request);
  return request;
}
